import { storyActions } from "../../actionTypes";

const initialState = {
	stories: {},
	fetching: false,
	fetched: false,
	error: null,
};

const Reducer = (state = initialState, action) => {
	switch (action.type) {
		case storyActions.FETCH_STORIES: {
			return { ...state, fetching: true };
		}

		case storyActions.RESET_STORIES_STATE:
			return { ...initialState };

		case storyActions.FETCH_STORIES_FULFILLED: {
			return {
				...state,
				fetching: false,
				fetched: true,
				stories: action.payload,
			};
		}

		case storyActions.FETCH_STORIES_REJECTED: {
			return { ...state, fetching: false, error: action.payload };
		}

		default:
	}

	return state;
};

export default Reducer;
